import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/voice-playground/')({
    head: () => ({
        meta: [
            {
                title: 'Voice Playground | Phoebe',
            },
        ],
    }),
});
